import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { getAllAgreement, deleteAgreement, saveStatusAgreement, getViewHistorical } from '../../services/agreement/agreements';
import { cedimi } from '../../constant/globalConstantsTypeClients'
import { updateHistoricalCustomer } from '../../services/clients/clients';


import * as XLSX from 'xlsx';



export const useAgreement = () => {

    //#region GLOBAL VARIABLES
    const history = useHistory();
    let id_branch = localStorage.getItem('branchId');
    //#endregion

    //#region MODALS
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [method, setMethod] = useState("");

    // ? DELETE AGREEMENT
    const [codeAgreement, setCodeAgreement] = useState("")
    const [isDelete, setIsDelete] = useState(false)
    const [valueCode, setValueCode] = useState("");

    const [loadingHistoric, setLoadingHistoric] = useState(false)
    const [labelAgreement, setLabelAgreement] = useState("")
    const [labeldataCustomer, setDataCustomer] = useState([])
    const [modalviewHistoric, setModalviewHistoric] = useState(false);

    let _url = localStorage.getItem('url_helen');



    const toggleHistoric = () => {
        setModalviewHistoric(!modalviewHistoric);

    }

    const toggle = () => {
        setModal(!modal);
        setIsDelete(false);
        setValueCode("")
    }

    //#endregion

    //#region DISPLAY MESSAGES
    const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate, sweetDeleteBacterium1, sweetDoctorDelete, sweetAgreements, sweetAgreementMode, sweetConfirmationCsv, sweetDeleteGlobal, sweetAcceptGlobal, sweetAlertGlobal] = useSweetAlert();
    //#endregion    

    //#region AGREEMENTS 

    //#region MODELS
    //LIST
    const [agreements, setAgreements] = useState([]);
    const [listAgreementsSearch, setListAgreementsSearch] = useState([]);

    //MODEL
    const [agreementId, setAgreementId] = useState(0);

    //FORM
    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        name_company: "",
        contract_number: "",
        validity: "",
        status: false,
    });

    const { name_company, contract_number, validity, status } = formValues;

    //#endregion

    //#region USE EFFECTS
    useEffect(() => {

        getAgreements();

    }, []);
    //#endregion

    //#region METHODS

    //#region NAVIGATEMETHODS

    const navigateNewAgreement = () => {
        history.push("../convenios/nuevo-convenio");
    }

    const navigateUpdate = (id_agreement) => {
        history.push(`../convenios/${id_agreement}/editar-convenio`);
    }
    //#endregion

    //#region GET METHODS
    //    "agreement_mode": "Tarifario Madre descuento del 50%",
    const getAgreements = async () => {
        const agree = await getAllAgreement();

        if (agree.code === 200) {
            if (agree?.data.length > 0) {

                const today = new Date();

                const list = agree.data.map(_find => {
                    const validityDate = new Date(_find.validity);
                    const expiracion = validityDate < today;

                    return {
                        id_agreement: _find?.id_agreement,
                        id_commercial_line: _find?.id_commercial_line,
                        id_company: _find?.id_company,
                        name_company: _find?.name_company,
                        contract_number: _find?.contract_number,
                        validity: _find?.validity,
                        expiracion,
                        status: _find?.status,
                        financing_method_name: _find?.financing_method_name,
                        agreement_mode:
                            _find?.agreement_mode === "Listado Actual"
                                ? (_url === cedimi
                                    ? "Precio Especial"
                                    : _find?.agreement_mode)
                                : _find?.agreement_mode,

                        agreement_discount_global:
                            _find?.agreement_discount_global ?? 0,
                        username_microsite: _find?.username_microsite,
                        password_microsite: _find?.password_microsite,
                        id_payment_configuration: _find?.id_payment_configuration === 1 ? "Factura vencida" : _find?.id_payment_configuration === 3 ? "Días de crédito" : _find?.id_payment_configuration === 4 ? "Contado" : "Sin configuración asignada",
                        automatic_lock: _find?.automatic_lock === 1 ? "Si" : "No",
                        credit_days: _find?.credit_days || "No especificado",
                        method_of_payment: _find?.method_of_payment || "No especificado"
                    };
                });

                setAgreements(list);
                setListAgreementsSearch(list);
            }
        } else {
            createSweet("error", "warning", "Convenios", agree.data.msg || "Ocurrió un error");
            setAgreements([]);
            setListAgreementsSearch([]);
        }
    };


    //#endregion



    //#region HANDLE METHDOS
    const handleDelete = (id_agreement) => {

        let agreement = agreements.find(a => a.id_agreement === id_agreement);

        handleUpdateValues({
            name_company: agreement.name_company,
            contract_number: agreement.contract_number,
            validity: agreement.validity
        });

        setAgreementId(id_agreement);
        setMethod("delete");
        setModalTitle(`Convenio: ${agreement.contract_number} `);
        setCodeAgreement(agreement.contract_number)
        toggle();
        setIsDelete(false);

    }


    const handleUpdateStatus = (id_agreement) => {

        let agreement = listAgreementsSearch.find(a => a.id_agreement === parseInt(id_agreement));

        let _active = agreement.status ? "Desactivar" : "Activar"

        handleUpdateValues({
            name_company: agreement.name_company,
            contract_number: agreement.contract_number,
            validity: agreement.validity,
            status: agreement.status
        });

        setAgreementId(id_agreement);
        setMethod("updateStatus");
        setModalTitle(` ${_active} convenio: ${agreement.contract_number} `);
        toggle();
    }


    //#endregion

    //#region METHODS POST & PUT

    const confirmationDelete = async () => {
        setIsDelete(true)
    }

    const saveDelete = async () => {
        if (valueCode !== codeAgreement) {
            createSweett(
                "Error",
                `El código ${valueCode} no corresponde con el del convenio.`,
                "error"
            );
            return;
        }

        setLoading(true)

        const response = await deleteAgreement({
            agreementId: agreementId
        });


        const historyList = [
            {
                site: "Edición de convenio",
                url: `/api/Agreement/${agreementId}`,
                method: "DELETE",
                action_delete: true,
                id_agreement: agreementId,

            }
        ];
        console.log("🚀 ~ saveDelete ~ historyList:", historyList)




        if (response.code === 200) {

            const data = await updateHistoricalCustomer({
                historyList
            });
            console.log("🚀 ~ saveUpdatePatient ~ data:", data)





            getAgreements();
            setLoading(false);
            createSweet("create", "success", ` ${modalTitle} eliminado correctamente`);
            toggle();
            setIsDelete(false);
            setValueCode("")
        }
        else {
            createSweet("error", "warning", "Convenios", response.data.msg || "Ocurrior un error");
            setLoading(false)
            setIsDelete(false);


        }
    }

    const saveUpdateStatus = async (e) => {
        e.preventDefault();
        setLoading(true)

        const response = await saveStatusAgreement(agreementId, !formValues.status);

        if (response.code === 200) {
            createSweet("create", "success", ` ${modalTitle} correctamente`);
            toggle();
            setLoading(false);
            getAgreements();
        }
        else {
            createSweet("error", "warning", "Convenios", response.data.msg || "Ocurrio un error");
            setLoading(false)
        }
    }
    //#endregion




    // ? CUSTOMER HISTORIC
    const handleViewCompany = async (id_agreement, _company) => {
        setLoadingHistoric(true);

        const response = await getViewHistorical(id_agreement);


        if (response?.code === 200) {

            const formattedData = response?.data.map(item => ({
                ...item,

                original_information:
                    item?.original_information?.toLowerCase() === "true"
                        ? "Sí"
                        : item?.original_information?.toLowerCase() === "false"
                            ? "No"
                            : item?.original_information,

                updated_information:
                    item?.updated_information?.toLowerCase() === "true"
                        ? "Sí"
                        : item?.updated_information?.toLowerCase() === "false"
                            ? "No"
                            : item?.updated_information
            }));

            setLabelAgreement(_company);
            setDataCustomer(formattedData);

        } else {
            setDataCustomer([]);
        }

        setTimeout(() => {
            setLoadingHistoric(false);
            toggleHistoric();
        }, 500);
    };


    // * DOWLOAND PRICES

    const downdloadExcel = async (_id_agreement, _idBranch, _id_commercial_line) => {

        let _token = localStorage.getItem("token");

        try {
            const response = await fetch(`/api/Agreement/DownloadAgreementPrices/${_id_agreement}/${_idBranch}/${_id_commercial_line}`, {
                method: 'GET',
                headers: {
                    "Authorization": "Bearer " + _token,
                    "Content-Type": "application/vnd.ms-excel"
                }
            });

            if (!response.ok) {
                throw new Error(`Error en la descarga: ${response.status} - ${response.statusText}`);
            }

            const blob = await response.blob();

            if (blob.size === 0) {
                console.warn("El archivo Excel está vacío. No se descargará.");
                return;
            }

            var url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Reporte_De_Precios.xlsx");
            document.body.appendChild(link);
            link.style.display = 'none';
            link.click();

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error al descargar el archivo:", error.message);
            alert("No se pudo descargar el archivo. Intente nuevamente.");
        }
    }

    // * DOWLOAND INFO
    const exportExcel = () => {
        if (!agreements || agreements.length === 0) return;

        const exportData = agreements.map((_agreement, index) => {
            return {
                "#": index + 1,
                "N° de contrato": _agreement?.contract_number || "",
                "Cliente": _agreement?.name_company || "",
                "Esquema de cobro": _agreement?.method_of_payment || "Sin especificar",
                "Modo de convenio": _agreement?.agreement_mode || "Sin especificar",
                "Descuento Global": _agreement?.agreement_discount_global || "0",
                "Configuración de cobranza": _agreement?.method_of_payment === "Contado(Al paciente)" ? "No aplicable" : _agreement?.id_payment_configuration || "Sin asignar",
                "Plazo de crédito": _agreement?.credit_days || "Sin especificar",
                "Estatus": _agreement?.status ? "Activo" : "Desactivado" || "Inactivo",
                "Usuario de micrositio": _agreement?.username_microsite || "No asignado",
                "Password micrositio": _agreement?.password_microsite || "No asignado",
                "Valido hasta": _agreement?.validity || "",
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Vinculación de Analitos');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const fileName = `Listado de convenios.xlsx`;
        const url = window.URL.createObjectURL(dataBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };


    //#endregion

    return {

        // ? DATA 
        modal, modalTitle, toggle, method, loading, name_company, contract_number, validity, status,
        navigateNewAgreement, navigateUpdate, agreements,

        // ? METHODS GLOBALS
        handleDelete, saveDelete, handleUpdateStatus, saveUpdateStatus,

        //*dowload excel 
        downdloadExcel, exportExcel, id_branch,

        // * DELETE AGREEMENT
        confirmationDelete, isDelete, valueCode, setValueCode,

        // * CONFIGURATION HISTORIC
        handleViewCompany, loadingHistoric, labelAgreement, labeldataCustomer, modalviewHistoric, toggleHistoric
    }
}
